import { FunctionComponent, useContext } from 'react'
import contextToiTeaser from '@contexts/toiTeaser'
import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import { ImageCrops } from '../types'
import { computeImageWidth } from './utils'

interface TeaserImageProps {
  src: string
  alt: string
  availableCrops?: ImageCrops
}

const { TOITeaserLayoutContext } = contextToiTeaser

const TeaserImage: FunctionComponent<TeaserImageProps> = ({
  src,
  alt,
  availableCrops,
}) => {
  const { teaserRatio, teaserFlex } = useContext(TOITeaserLayoutContext)
  const computedImageWidth = computeImageWidth(teaserFlex)

  return (
    <ResponsiveImageV2
      src={src}
      alt={alt}
      ratios={teaserRatio}
      crops={availableCrops ?? {}}
      widths={computedImageWidth}
    />
  )
}

export default TeaserImage
